export const capitalizeFirstLetter = (str?: string | null) => {
    if(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
};

export const camelToKebab = (str = '') => {
    return str
        .split('')
        .map((letter, idx) => {
            if(letter.toUpperCase() === letter) {
                return `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}`;
            }

            return letter;
        })
        .join('');
};

export const kebabToCamel = (str: string) => {
    return str.replace(/-./g, (word) => word[1].toUpperCase());
};

export const convertToPascal = (str?: string) => {
    return str?.replace(/(^\w|-\w)/g, (word) => {
        return word.replace(/-/, '').toUpperCase();
    });
};

export const convertSnakeToKebab = (str: string) => {
    return str.replace(/_/g, '-');
};

export const getTypesObjectKeys = Object.keys as <T extends object>(obj: T) => Array<keyof T>;

export const isNumber = (value: string | number | null | undefined): boolean => {
    return !Number.isNaN(Number(value)) && value !== undefined && value !== null;
};

export const getOnlyNum = (value: string) => {
    const ONLY_NUMBER_PATTERN = /[^\d]/g;

    return value.replace(ONLY_NUMBER_PATTERN, '');
};
